import Vue from 'vue';

// Manipulação de cookies do navegador
// https://github.com/cmp-cc/vue-cookies
// default options config: { expires: '1d', path: '/', domain: '', secure: false, sameSite: 'Lax' }
let domain = window.location.hostname;
import VueCookies from 'vue-cookies';
Vue.use(VueCookies, { expire: '3d', domain: domain, sameSite: 'Lax' });

// Internacionalização, chaves de texto
// https://github.com/kazupon/vue-i18n
import i18n from './i18n/i18n.js';

import App from './App.vue';
import router from './router/router';
import store from './store/vuex.js';

Vue.config.productionTip = false;

import * as Util from './functions/Util.js';
import * as Init from './functions/Init.js';

// Comunicação http
// https://github.com/axios/axios
// https://axios-http.com/docs/intro
import axios from './plugins/axios.js';
Vue.prototype.$axios = axios;
// Verificação inicial de dados do usuário

import 'intl';
import 'intl/locale-data/jsonp/pt-BR';
import 'intl/locale-data/jsonp/en-US';
import 'intl/locale-data/jsonp/es-ES';

// Temas do VueTippy
import 'text-security/text-security.css';
import 'tippy.js/themes/light-border.css';
import 'tippy.js/themes/google.css';

require('moment/locale/pt-br.js');

if (
    typeof global.Intl == 'undefined' ||
    typeof global.Intl.NumberFormat().formatToParts == 'undefined'
) {
    global.Intl = global.IntlPolyfill;
}

Vue.filter('formatCpfCnpj', Util.formatCpfCnpj);
Vue.filter('decimal', Util.getDecimal);
Vue.filter('cutString', Util.cutString);

import { setUse } from './functions/Use.js';
setUse(Vue);

import { setComponents } from './functions/Components.js';
setComponents(Vue);

Vue.http.options.root = process.env.VUE_APP_API_URL;

Vue.mixin({
    methods: {
        ...Util,
    },
});

// Usuário atual, utiliza o token para carregá-lo
let logged = $cookies.get('token')
    ? JSON.parse(window.atob($cookies.get('token').split('.')[1])).sub
    : '[ANÔNIMO]';
console.log(`Carregando usuário ${logged}`);

setTimeout(() => {
    Init.getTheme(store).finally((_) => {
        getUsuario();
    });
}, 300);

const getUsuario = () => {
    Init.getUsuario(store, true)
        .then((res) => {
            getUsuarioMenu();
        })
        .catch(() => {
            if (!store.state.authenticated) {
                // router.push({ name: 'login' });
                $cookies.remove('keepLogged');
                $cookies.remove('version');
                $cookies.remove('token');
                store.dispatch('user', { value: null });
                store.dispatch('context', { value: null });
                store.dispatch('logoutUser', { value: false });
                startVue();
            }
        });
};

const getUsuarioMenu = () => {
    Init.getUsuarioMenu(store)
        .then((res) => {})
        .finally((_) => {
            getModuloPDA();
        });
};

const getModuloPDA = () => {
    Init.getModuloPDA(store)
        .then((res) => {})
        .finally((_) => {
            getEmpresa();
        });
};

const getEmpresa = () => {
    Init.getEmpresa(store)
        .then((res) => {})
        .finally((_) => {
            startVue();
        });
};

function startVue() {
    new Vue({
        i18n,
        router,
        store,
        render: (h) => h(App),
    }).$mount('#app');
}
